<template>
            <div>
                <section>
                   
                    <div class="relative">
                        <div class="sm:flex block mx-auto my-20 justify-center items-center">
                        <div class="z-10">
                            <div class="rounded-full mx-auto mb-5">
                            <img src="../assets/pages/pose-m-5.png" alt="" >        
                            </div>
                        </div>
                        
                      <!--   <div class="absolute rounded top-0 right-0">
                            <img src="../assets/images/instructor-8.png" alt="" class="opacity-40 sm:opacity-70">
                        </div> -->
                        <div class="z-10">
                            <div class="mx-auto w-4/5 text-left font-raleway z-10">
                            <h1 class="font-bold text-black text-6xl mb-10">
                                DIE BESTEN KURSE
                                <br>
                                AUF DIE DU GEWARTET HAST
                            </h1>
<!--                             <p class="text-sm tracking-wide font-montserrat mb-10">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                                <br>
                                Facilis ex iure rem vero voluptate, sint praesentium quidem,
                                <br>
                                eius sequi, officia itaque? Eveniet quaerat eos qui sunt suscipit nisi sequi? Soluta.
                            </p> -->
                            <router-link to='/courses' class="text-xl mb-5 sm:mb-0 text-black font-bold font-raleway">
                                    ENTDECKEN
                                <font-awesome-icon class="" :icon="['fas', 'arrow-right']" /> 
                            </router-link>     
                            </div>
                        </div>
                        </div>
                    </div>
               
                    <br>

                </section>
                

            </div>
        </template>
        <script>
  

            export default {
                name: 'StudentSection',
                components: {
                  
                },
            }
        </script>
        <style scoped>
        </style>